import React, { FC } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import Metric from 'components_new/pages/Metric'
import MetricSettings from 'components_new/pages/MetricSettings'
import Metrics from 'components_new/pages/Metrics'

import { useIsAuthenticated } from 'redux/hooks/SignedInAccount'

import AuthRoute from './AuthRoute'

const Routes: FC = () => {
  const isAuthenticated = useIsAuthenticated()

  return (
    <Switch>
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <MetricSettings />}
        path={'/metrics/:id/settings'}
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <Metric />}
        path={'/metrics/:id'}
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <Metrics />}
        path={'/metrics'}
      />
      <Route path={'/metrics/*'}>
        <Redirect to="/metrics" />
      </Route>
    </Switch>
  )
}

export default Routes
